import {Control} from 'ol/control';

export class RulerControl extends Control {
    epMap = null;

    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
        const options = opt_options || {};

        const button = document.createElement('button');
        button.type = 'button';
        button.innerHTML = '<i style="font-size: 14px" class="fas fa-ruler"></i>';

        const element = document.createElement('div');
        element.className = 'ol-ruler-control ol-unselectable ol-control';
        element.appendChild(button);

        super({
            element: element,
            target: options.target,
        });

        button.addEventListener('click', this.handleClick.bind(this), false);

        this.epMap = options.epMap ?? null;
    }

    handleClick() {
        if(this.epMap && this.epMap.ruler) {
            this.epMap.ruler.start();
        }
    }
}
